import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {BelService} from "../../../common/services/bel/bel/bel.service";
import {Bel} from "../../../common/services/bel/bel/bel.model";
import {SubSink} from '@Common/core/utils/subsink';


@Component({
  selector: 'app-bel-view',
  templateUrl: './bel-view.component.html',
  styleUrls: ['./../style/bel.scss'],
})
export class BelViewComponent implements OnInit {

  title = '';
  iconTitle = 'remove_red_eye';
  SubSink = new SubSink();
  Bel: Bel = <Bel>{};
  extraParams: Map<string, string> = new Map<string, string>();
  constructor(private router: Router,
              private route: ActivatedRoute,
              public belSvc: BelService) { }

  ngOnInit(): void {
    this._getBel();
  }

  private _getBel(): void {
    const id = this.route.snapshot.params['id'];
    if(id && id !== 0){
      this.extraParams.set('bel', id.toString());
      this.SubSink.sink = this.belSvc.get(id).subscribe((_bel) => {
        this.Bel = _bel;
        this.title = `Visualisation du BEL: ${this.Bel.label} (${this.Bel.reference})`;
      });
    }
  }

  goList(): void {
    this.router.navigate(['gestion'], { queryParams: { tab: "eliminations"}});
  }

}
